// extracted by mini-css-extract-plugin
export var author = "NameWithPubdate-module--author--0e672";
export var authorImg = "NameWithPubdate-module--authorImg--b53cc";
export var img = "NameWithPubdate-module--img--2e427";